import { useParams, Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { storesApi } from '@/api/stores';
import { extractApiError } from '@/api/client';
import { MenuOfferingTab } from './stores/MenuOfferingTab';

export function StoreMenuOfferingsPage() {
  const { id } = useParams<{ id: string }>();
  const storeId = id!;

  const {
    data: store,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['stores', storeId],
    queryFn: () => storesApi.get(storeId),
    staleTime: 60_000,
  });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16, padding: '0 4px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <Link
          to="/business/stores"
          style={{ color: 'var(--text-link)', textDecoration: 'none', fontSize: 13 }}
        >
          ← 매장 목록
        </Link>
        {!isLoading && store && (
          <h1 className="kuun-h2" style={{ margin: 0 }}>
            {store.name}
            {store.branchName ? ` ${store.branchName}` : ''} 메뉴 구성
          </h1>
        )}
        {error && (
          <span style={{ color: 'var(--color-error)' }}>
            매장 정보를 불러오지 못했습니다. {extractApiError(error)}
          </span>
        )}
      </div>

      <MenuOfferingTab storeId={storeId} />
    </div>
  );
}
